import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getUnappliedGroupsForSchedule = api(async function getUnappliedGroupsForSchedule({
    projectId,
    scheduleId,
}) {
    if (!projectId || !scheduleId) return []
    return query(
        gql`
            query GetUnappliedGroupsForSchedule($projectId: String!, $scheduleId: String!) {
                getUnappliedGroupsForSchedule(projectId: $projectId, scheduleId: $scheduleId) {
                    id
                    name
                    type
                }
            }
        `,
        { projectId, scheduleId },
        { returns: "getUnappliedGroupsForSchedule" }
    )
})
